import { useLayoutEffect, useState } from 'react';

// Geometry is a projection only. Moving the iframe itself between DOM parents
// would reload the provider session, so the one body-owned frame follows slots.
export default function useGameFrameSlot(mode, enabled) {
  const [rect, setRect] = useState(null);
  useLayoutEffect(() => {
    if (!enabled) { setRect(null); return undefined; }
    let slot;
    let frame;
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    function measure() {
      const next = document.querySelector(`[data-game-frame-slot="${mode}"]`);
      if (next !== slot) {
        resize?.disconnect();
        slot = next;
        if (slot) resize?.observe(slot);
      }
      if (!slot) { setRect(null); return; }
      const box = slot.getBoundingClientRect();
      const nextRect = { top: box.top, left: box.left, width: box.width, height: box.height };
      setRect((previous) => previous && Object.keys(nextRect).every((key) => previous[key] === nextRect[key]) ? previous : nextRect);
    }
    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => { frame = null; measure(); });
    };
    const mutation = new MutationObserver(schedule);
    mutation.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('scroll', schedule, true);
    window.addEventListener('transitionend', schedule, true);
    window.addEventListener('animationend', schedule, true);
    measure();
    return () => {
      resize?.disconnect();
      mutation.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('scroll', schedule, true);
      window.removeEventListener('transitionend', schedule, true);
      window.removeEventListener('animationend', schedule, true);
    };
  }, [mode, enabled]);
  return rect;
}
